// The formula_config a new Zulage starts with, per allowance type (the keys of
// TimesheetTemplateAllowance::ALLOWANCE_TYPES). Shared by the template builder and the
// Zulagen-Profil page, which both create Zulagen from the same "+ Zulage hinzufügen" menu.
const RANGE_DEFAULTS = {
  mileage_calculation_mode: "fixed_per_range",
  mileage_ranges: [{ from: 0, to: "", fixed_amount: 0, per_km_rate: 0 }],
}

const DEFAULT_FORMULA_CONFIGS = {
  nachtzulage: {
    reference_time_from: "06:00",
    reference_time_to: "18:00",
  },
  sonntagszulage: { trigger_days: [0] },
  feiertagszulage: {},
  kilometergeldzulage: RANGE_DEFAULTS,
  unterkunft_baustelle: RANGE_DEFAULTS,
  verpflegungspauschale: { fixed_amount: 0 },
  entfernungspauschale: {
    fixed_amount: 0,
    distance_threshold_km: 6,
    distance_method: "air_distance",
    distance_origin: "company_hq",
  },
  stundenzulage: { rate: 0 },
  stundenlohn_multiplikator: { multiplier: 1.0 },
  tagespauschale: { fixed_amount: 0 },
  eintragspauschale: { fixed_amount: 0 },
  prozent_vom_lohn: { percentage: 0 },
  wochentliches_fahrgeld: { per_km_rate: 0.4 },
  baustelle_baustelle_zulage: RANGE_DEFAULTS,
  benutzerdefiniert: { expression: "", variables: [] },
}

// A fresh copy, so a caller mutating the result cannot change the defaults.
export function defaultFormulaConfig(typeKey) {
  return structuredClone(DEFAULT_FORMULA_CONFIGS[typeKey] || {})
}
